export default __webpack_public_path__ + "static/media/mindwrack.0d2ebc73.png";